import projection from '../generated/pwj515f1.json';
import { AcceptanceManifest } from '../types';
export const pwj515f1AcceptanceManifest = projection as AcceptanceManifest;
